<template>
  <div class="description_text">
    <div v-if="title" class="title">{{title}}</div>
    <el-row :gutter="gutter">
      <el-col :key="key" :xs="24" :sm="12" :lg="8" v-for="(item, key) in dataSource">
        <el-row :gutter="gutter" class="row">
          <el-col :span="10">
            <div class="term">{{$t(item.term)}}</div>
          </el-col>
          <el-col :span="14">
            <div class="detail" v-html="item.detail"></div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const handleArrayObj = data => {
  return data
    .filter(item => item.tag === 'Description')
    .map(item => ({
      tag: item.tag,
      term: (item.data && item.data.attrs.term) || '',
      detail: (item.children && item.children[0].text) || ''
    }))
}

export default {
  name: 'Description',
  props: {
    title: String,
    content: [Object, Array],
    gutter: {
      type: [Number, String],
      default: 20
    },
    col: {
      type: [Number, String],
      default: 8
    }
  },

  data () {
    return {
      dataSource: handleArrayObj(this.$slots.default || [])
    }
  },
  watch: {
    content () {
      this.dataSource = handleArrayObj(this.$slots.default || [])
    } // 监听重渲染
  }
}
</script>

<style lang="less" scoped>
.description_text {
  .row{
    padding: 2px 0;
  }
  padding-bottom: 20px;
  .title {
    padding: 10px;
    background: #f3f3f3;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 20px;
    color: #0e5099;
  }
  .term {
    color: #0e5099;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 8px 0;
    margin-right: 8px;
    white-space: nowrap;
    display: table-cell;
    &:after {
      content: ":";
      margin: 0 8px 0 2px;
      position: relative;
      top: -0.5px;
    }
  }
  .detail {
    //padding-left: 50px;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    padding: 8px 0;
    color: #000;
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// src/card/components/Description.vue